import React, { useState } from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Select from 'react-select';
import QueryByDate from './QueryByDate';
import { queryCategories } from '../../../mockups/User/interests';


const EnhancedSearchBar = ({ onSearch, clicked }) => {

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [userCount, setUserCount] = useState(100);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ])
  


const dateFormatChange = (dateString) => {
    let dateObj = new Date(dateString);
    // Convert to UTC, add microseconds (simulating them here)
    let isoDateString = new Date(dateObj.getTime() + 587642).toISOString();
    return isoDateString
}


  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({
      query: selectedCategories.map(cat => cat.value),
      start_date: dateFormatChange(dateRange[0]?.startDate), 
      end_date: dateFormatChange(dateRange[0]?.endDate),
      user_count: userCount
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">

    <div className=''>
      <QueryByDate
      dateRange={dateRange}
      handleChange={item => {
      setDateRange([item.selection])
      }}
      />
    </div>

      <Select
        isMulti
        options={queryCategories}
        value={selectedCategories}
        onChange={setSelectedCategories}
        placeholder="Select categories"
        className="w-full text-black"
      />


      <div>
        <label htmlFor="userCount" className="block text-sm font-medium text-white">
          Number of Users
        </label>
        <input
          type="number"
          id="userCount"
          value={userCount}
          onChange={(e) => setUserCount(parseInt(e.target.value))}
          className="mt-1 block text-black w-full rounded-md border-gray-300
           shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200
           focus:ring-opacity-50"
        />
      </div>

      <div className='flex justify-end'>
      <button
      type='submit'
      className='flex justify-center w-full sm:w-1/4 my-4 sm:m-4 rounded-md py-2 px-6
      text-white bg-updatedPurple hover:bg-[#767cb9]'
      onClick={handleSubmit}>
      {clicked ?
      <div
      className="animate-spin rounded-full h-6 w-6 py-2
      border-t-4 border-white"
      /> 
      :
        'Search'
      }
      </button>
      </div>
    </form>
  );
};

export default EnhancedSearchBar;
